import * as i0 from "@angular/core";
export class CodeStore {
}
CodeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CodeStore_Factory() { return new CodeStore(); }, token: CodeStore, providedIn: "root" });
export var CodeStoreKeys;
(function (CodeStoreKeys) {
})(CodeStoreKeys || (CodeStoreKeys = {}));
